import { lazy, Suspense, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import { useAccount } from '../lib/account'
import { PLAN_ORDER } from '../lib/planGate'
import { ALL_LINKS } from './nav-config'
import DesktopSidebar from './DesktopSidebar'
import MobileNav from './MobileNav'
import StaffRoutes from './StaffRoutes'
import CrewTaxClassificationBanner from './CrewTaxClassificationBanner'

const AiChat = lazy(() => import('../components/AiChat'))
const CommandPalette = lazy(() => import('../components/CommandPalette'))

export default function StaffLayout() {
  const { profile, canAccessPage, isOwner } = useAuth()
  const navigate = useNavigate()
  const { plan } = useAccount()
  const canUseAi = PLAN_ORDER[plan] >= PLAN_ORDER['pro']
  const [collapsed, setCollapsed] = useState(false)
  const [chatOpen, setChatOpen] = useState(false)
  const [paletteOpen, setPaletteOpen] = useState(false)

  useEffect(() => {
    /** @param {KeyboardEvent} e */
    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setPaletteOpen(o => !o)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const links = ALL_LINKS.filter(l => {
    if (l.pageKey === 'field-work' && !profile?.contractor_id) return false
    return l.pageKey ? canAccessPage(l.pageKey) : l.roles.includes(/** @type {import('./nav-config').UserRole} */ (profile?.role))
  })

  return (
    <div className="min-h-screen bg-brand-50">
      <DesktopSidebar collapsed={collapsed} setCollapsed={setCollapsed} links={links} chatOpen={chatOpen} setChatOpen={setChatOpen} canUseAi={canUseAi} onOpenPalette={() => setPaletteOpen(true)} />
      <MobileNav links={links} chatOpen={chatOpen} setChatOpen={setChatOpen} canUseAi={canUseAi} />
      <main className={`transition-all duration-200 ${collapsed ? 'md:ml-16' : 'md:ml-56'}`}>
        <div className="p-4 md:p-6 max-w-7xl mx-auto pt-16 md:pt-6 pb-24 md:pb-6">
          {isOwner && <CrewTaxClassificationBanner />}
          <Suspense fallback={<div className="flex items-center justify-center py-32"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div></div>}>
            <StaffRoutes onNavigate={/** @param {string} page */ (page) => navigate('/' + page)} />
          </Suspense>
        </div>
      </main>
      {canUseAi && <Suspense fallback={null}><AiChat open={chatOpen} setOpen={setChatOpen} /></Suspense>}
      <Suspense fallback={null}>
        <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      </Suspense>
    </div>
  )
}
